"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames_1 = require("../../utilities/classNames");
var icons_1 = require("./../../utilities/icons");
var Icon = /** @class */ (function (_super) {
    tslib_1.__extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var _a = this.props, icon = _a.icon, className = _a.className, attrs = tslib_1.__rest(_a, ["icon", "className"]);
        return (React.createElement("i", tslib_1.__assign({}, attrs, { className: classNames_1.ClassHelpers.classNames(className, "icon", icon) })));
    };
    Icon.Icomoon = icons_1.Icons.Icomoon;
    return Icon;
}(React.Component));
exports.Icon = Icon;
